module.exports = __webpack_public_path__ + "static/media/achievement-ninja-shoes.0219968e.svg";